import { WidgetConfig } from '../../../models/widget.config';

export class RepeatableGroupWidgetConfig extends WidgetConfig<{}> {
  controlType = 'FormArray';
  widgetType = 'RepeatableGroupWidget';
  constructor(config: {} = {}) {
    super(config);
  }
}
